import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import '@babel/polyfill'
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import '@mdi/font/css/materialdesignicons.css'
import { config } from './config'
import './plugins/axios'
import './plugins/loadImage'
import './plugins/theMask'
import './plugins/global-components'
import moment from 'moment'

window.document.title = config.pageTitle;
moment.locale('pt-br');

Vue.config.productionTip = false;

store.dispatch('initializeApp');

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app');
